// extracted by mini-css-extract-plugin
export default {"component":"SearchBar__component--slots-GuYNR","focus":"SearchBar__focus--slots-eho21","input":"SearchBar__input--slots-lMFVb"};